import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../utils";
import { navButtonVariants } from "./nav-button.variants";
import type { NavButtonProps } from "./nav-button.types";
const NavButton = React.forwardRef<HTMLButtonElement, NavButtonProps>((t0, ref) => {
  const $ = _c(18);
  let active;
  let className;
  let props;
  let size;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      active,
      asChild: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = active;
    $[2] = className;
    $[3] = props;
    $[4] = size;
    $[5] = t1;
    $[6] = variant;
  } else {
    active = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
    t1 = $[5];
    variant = $[6];
  }
  const asChild = t1 === undefined ? false : t1;
  const Comp = asChild ? Slot : "button";
  const t2 = asChild ? undefined : "button";
  let t3;
  if ($[7] !== active || $[8] !== className || $[9] !== size || $[10] !== variant) {
    t3 = cn(navButtonVariants({
      variant,
      size,
      active,
      className
    }));
    $[7] = active;
    $[8] = className;
    $[9] = size;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== Comp || $[13] !== props || $[14] !== ref || $[15] !== t2 || $[16] !== t3) {
    t4 = <Comp ref={ref} data-slot="nav-button" type={t2} className={t3} {...props} />;
    $[12] = Comp;
    $[13] = props;
    $[14] = ref;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
});
NavButton.displayName = "NavButton";
export { NavButton };